import './index.less'
import styles from './index.module.less'
import React from 'react'
import Interceptor, { isGuest } from '../../common/Interceptor'
import PointsApi from '../../common/api'
import Clipboard from 'clipboard'
import dayjs from 'dayjs'
import ThinkingDataSDK from '@ssr/components/Analytics/ThinkingDataSdk'
import VolcEngine from '@ssr/components/Analytics/VolcEngine'
import { CommonContext } from '@ssr/context'

function formatDate(timestamp) {
  return dayjs(timestamp).format('YYYY/MM/DD')
}

class CouponCode extends React.Component {
  componentDidMount() {
    new Clipboard(this.dom)
  }
  render() {
    return (
      <span
        ref={(o) => {
          this.dom = o
        }}
        data-clipboard-text={this.props.code}>
        {this.props.text}
      </span>
    )
  }
}

class Main extends React.Component {
  state = {
    myList: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      myList: [],
    }
  }

  componentDidMount() {
    if (isGuest()) {
      return
    }

    PointsApi.lotteryGetJoinedProductList().then(({ data }) => {
      const { products } = data

      this.setState({ myList: products })
    })
  }

  render() {
    const { myList } = this.state
    const { __ } = this.props

    const statusMap = {
      win_lottery: __['app.points.lottery.copy_and_shop'],
      lose_lottery: __['app.points.lottery.status_lose'],
      over: __['app.points.lottery.status_ended'],
      default: __['app.points.lottery.status_running'],
    }

    return (
      <div>
        <div className={styles.mine_header}>{__['app.points.lottery.my_lottery']}</div>

        <div className={styles.product_list}>
          {myList.map((p) => {
            const info = p.info || {}
            const storeLink = p.prize_link
            const hasCode = p.awards_type === 0

            return (
              <div className={[styles.product, p.status === 'win_lottery' ? styles.win : '', p.status === 'lose_lottery' ? styles.lose : ''].join(' ')} key={p.id}>
                <div className={styles.cover}>
                  <img src={p.picture_url} alt='' />
                  <div className={styles.mask}>WIN</div>
                </div>

                <div className={styles.text}>
                  <div className={styles.name}>{info.name}</div>
                  <div className={styles.desc}>{info.description}</div>
                  {p.status === 'win_lottery' && p.code_expiration_time ? (
                    <div className={styles.expiration_time}>
                      {__['app.points.lottery.expiration_date']}
                      {formatDate(p.code_expiration_time)}
                    </div>
                  ) : null}
                </div>

                {p.status === 'win_lottery' && storeLink ? (
                  hasCode ? (
                    <div className={styles.status_wrapper}>
                      <a className={styles.status} href={storeLink}>
                        <CouponCode code={p.code} text={statusMap['win_lottery']} />
                      </a>
                      <div className={styles.code}>
                        <div>{__['app.points.lottery.coupon_code']}:</div>
                        <div>{p.code}</div>
                      </div>
                    </div>
                  ) : null
                ) : (
                  <div className={styles.status_wrapper}>
                    <a className={styles.status}>{statusMap[p.status] || statusMap.default}</a>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

function Page() {
  const { __, locale } = React.useContext(CommonContext)
  return (
    <>
      <Interceptor>
        <Main __={__} locale={locale} />
      </Interceptor>
      <ThinkingDataSDK />
      <VolcEngine />
    </>
  )
}

Page.injectData = function ({ locals }) {
  return {
    localeData: {
      namespaces: ['common', 'app'],
    },
  }
}

export default Page
